var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContinueStatus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15988",
    "data-name": "Group 15988",
    transform: "translate(-341 -236)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73350",
    "data-name": "Path 73350",
    d: "M10,20A10,10,0,1,0,0,10,10,10,0,0,0,10,20Z",
    transform: "translate(341 236)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73351",
    "data-name": "Path 73351",
    d: "M1.985,3.97A1.985,1.985,0,1,1,3.97,1.985,1.985,1.985,0,0,1,1.985,3.97Z",
    transform: "translate(354.351 244.015)",
    fill: "#ebbe29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73349",
    "data-name": "Path 73349",
    d: "M2.241,69.437a.823.823,0,0,1,0-1.163l4.108-4.108a.822.822,0,0,1,1.163,1.163L4.8,68.035h5.418a.822.822,0,1,1,0,1.643H4.806l2.7,2.706a.822.822,0,0,1-1.163,1.163L2.238,69.439Z",
    transform: "translate(342.192 177.143)",
    fill: "#ebbe29"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContinueStatus);
export default __webpack_public_path__ + "static/media/continue-status.94fc627932e1787c81abf408e30ec96f.svg";
export { ForwardRef as ReactComponent };